import { MasterDataStatusKeyInfo } from '@/items/MasterDataStatus';
import { OrderStatusKeyInfo } from '@/items/OrderStatus';
import { PurchaseOrder, PurchaseOrderKeyInfo } from '@/models/PurchaseOrder';
import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component<CreatePurchaseOrderCard>({})
export default class CreatePurchaseOrderCard extends Vue {

  // #region @PropSyncs

  @PropSync('purchaseOrderSync')
  protected purchaseOrder!: null | PurchaseOrder;

  @PropSync('isFormValidSync')
  protected isFormValid!: boolean;


  // #endregion

  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected PurchaseOrderKeyInfo = PurchaseOrderKeyInfo;

  protected OrderStatusKeyInfo = OrderStatusKeyInfo;

  protected MasterDataStatusKeyInfo = MasterDataStatusKeyInfo;

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get gap(): string {
    return ['sm', 'lg', 'xl'].includes(this.$vuetify.breakpoint.name)
      ? '16'
      : '0';
  }

  protected get purchaseOrderOrderStatusText(): string {
    if (!this.purchaseOrder || !this.purchaseOrder.status) { return ''; }

    return OrderStatusKeyInfo[this.purchaseOrder.status]
      && OrderStatusKeyInfo[this.purchaseOrder.status].labelShort
      ? OrderStatusKeyInfo[this.purchaseOrder.status].labelShort
      : this.purchaseOrder.status;
  }

  protected get purchaseOrderMasterDataStatusText(): string {
    if (!this.purchaseOrder || !this.purchaseOrder.master_data_status) { return ''; }

    return MasterDataStatusKeyInfo[this.purchaseOrder.master_data_status]
      && MasterDataStatusKeyInfo[this.purchaseOrder.master_data_status].labelShort
      ? MasterDataStatusKeyInfo[this.purchaseOrder.master_data_status].labelShort
      : this.purchaseOrder.master_data_status;
  }

  // #endregion

  // #region @Watchers
  // #endregion
}
